class Tcl {
  public isTCLWebview = window.navigator.userAgent.includes('app/tcl_channel');
}
export default new Tcl();
